import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=2eb1ab76&scoped=true"
import script from "./userMenu.vue?vue&type=script&lang=js"
export * from "./userMenu.vue?vue&type=script&lang=js"
import style0 from "./userMenu.vue?vue&type=style&index=0&id=2eb1ab76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb1ab76",
  null
  
)

export default component.exports